import { CollapsibleContainerRef } from "mt-components/CollapsibleContainer/CollapsibleContainer";
import { MutableRefObject, useCallback } from "react";
import { AiOutlineHighlight } from "react-icons/ai";
import { FaImages, FaMapMarkerAlt } from "react-icons/fa";
import { MdOutlineSummarize, MdPolicy, MdReviews } from "react-icons/md";
import useWindowSize from "../../../../../utils/useWindowSize";
import { scrollToCollapsibleContainer } from "../../helpers";
import styles from "./ProductNavigation.module.css";

interface ProductDetailNavProps {
  setGalleryOpen: Function;
  navigationRef: MutableRefObject<HTMLDivElement>;
  reviewsRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  summaryRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  faqsRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  highlightsRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  locationRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  hasFAQ?: boolean;
}
export default function PlanDetailNav({
  faqsRef,
  hasFAQ,
  highlightsRef,
  locationRef,
  navigationRef,
  reviewsRef,
  setGalleryOpen,
  summaryRef,
}: ProductDetailNavProps) {
  const { isMobile } = useWindowSize();

  const scrollTo = useCallback(
    (
      containerRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>,
    ) => scrollToCollapsibleContainer(containerRef, navigationRef, isMobile),
    [isMobile, navigationRef],
  );

  return (
    <div className={styles["ProductDetailJumpers"]} ref={navigationRef}>
      <div className="AppLayout">
        <ul>
          <li onClick={() => setGalleryOpen(true)}>
            <span>
              <FaImages /> Photos
            </span>
          </li>
          <li onClick={() => scrollTo(summaryRef)}>
            <span>
              <MdOutlineSummarize /> Summary
            </span>
          </li>
          <li onClick={() => scrollTo(highlightsRef)}>
            <span>
              <AiOutlineHighlight /> Highlights
            </span>
          </li>
          <li onClick={() => scrollTo(locationRef)}>
            <span>
              <FaMapMarkerAlt /> Meeting Point
            </span>
          </li>
          {hasFAQ && (
            <li onClick={() => scrollTo(faqsRef)}>
              <span>
                <MdPolicy /> FAQs
              </span>
            </li>
          )}
          {reviewsRef !== null ? (
            <li onClick={() => scrollTo(reviewsRef)}>
              <span>
                <MdReviews /> Reviews
              </span>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
}
